import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import FuturesOIChangeSinceLastExpiryFull from './futures-oi-change-since-last-expiry-full';

export const FuturesOIChangeSinceLastExpiryFullWidget = (props) => {
  const queryClient = new QueryClient;
  return (
    <QueryClientProvider client={queryClient}>
      <FuturesOIChangeSinceLastExpiryFull {...props} />
    </QueryClientProvider>
  );
};
